module.exports = __webpack_public_path__ + "img/1.e711d88e.png";